import { IconCircleCheck } from "central-icons/IconCircleCheck";
import { IconCircleX } from "central-icons/IconCircleX";
import { IconBadge } from "@/components/ui/icon-badge";

interface ResultBadgeProps {
  bad?: boolean;
  className?: string;
  size?: "sm" | "md";
}

export function ResultBadge({
  bad = false,
  size = "md",
  className,
}: ResultBadgeProps) {
  return (
    <>
      <IconBadge
        className={className}
        color={bad ? "gray" : "sky"}
        icon={bad ? IconCircleX : IconCircleCheck}
        size={size}
      />
      <span className="sr-only">{bad ? "Not recommended" : "Recommended"}</span>
    </>
  );
}
